import { router, setPageContent } from "..";
import { sendVerificationCode } from "../api/send-verification-code";
import { verifyEmail } from "../api/verify-email";
import { errorSection } from "../error-section";
import { loadingScreen } from "../loading-screen";
import { t } from "../locale";
import { Bulma } from "../view/bulma";
import { centeredBox } from "../view/components";

/**
 * @param {import("navigo").Match | undefined} ctx
 */
function verifyEmailPage(ctx) {
	const email = Bulma.input({
		type: "email",
		value: ctx?.params?.email,
	});

	if (ctx?.params?.email) {
		// Update browser url, remove email from query params
		delete ctx.params.email;
		window.history.replaceState(null, "", ctx.url);
	}

	const verificationCode = Bulma.input({
		type: "text",
	});

	function onClickVerify() {
		const attempt = errorSection.attempt(async () => {
			await verifyEmail(email.getValue(), verificationCode.getValue());
			router.jump(`/sign-in?email=${email.getValue()}`);
		});
		loadingScreen.waitFor(attempt);
	}

	const onClickResend = () => {
		const attempt = errorSection.attempt(async () =>
			sendVerificationCode(email.getValue()),
		);
		loadingScreen.waitFor(attempt);
	};

	setPageContent(
		centeredBox(
			"small",
			Bulma.title(t.verifyAccount),
			Bulma.title(t.verificationCodeInstruction, "is-6"),
			Bulma.field(
				{},
				Bulma.label(t.email),
				Bulma.control({}, email.element),
			),
			Bulma.field(
				{},
				Bulma.label(t.verificationCode),
				Bulma.control({}, verificationCode.element),
			),
			Bulma.buttons(
				Bulma.button(
					{
						onClick: onClickResend,
						styles: ["is-primary"],
					},
					t.sendVerificationCode,
				),
			),
			document.createElement("hr"),
			Bulma.buttons(
				Bulma.button(
					{
						onClick: onClickVerify,
						styles: ["is-primary"],
					},
					t.confirm,
				),
				Bulma.button(
					{
						onClick: () => router.jump("/sign-in"),
						styles: ["is-primary"],
					},
					t.cancel,
				),
			),
		),
	);
}

export { verifyEmailPage };
